<template>
  <div id="container" ref="mapRef" class="mainBox"></div>
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <div class="topContent">
        <div class="dh_wz">
          <div class="dh_wz_qq"></div>
          <div class="dh_wz_tb"></div>
          <div class="dh_wz_wz">高标准农田</div>
        </div>
        <div class="dh_lb">
          <router-link :to="{path:'/gbzntyj'}"><div class="dh_lb_bt dh_lb_bt_cur">项目总览</div></router-link>
          <router-link :to="{path:'/plant'}"><div class="dh_lb_bt">高标准农田</div></router-link>
           <!-- <router-link :to="{path:'/gbzntjs'}"><div class="dh_lb_bt">项目进度</div></router-link> -->
          <!-- <router-link :to="{path:'/zuowufenxi'}"><div class="dh_lb_bt">农作物分析</div></router-link> -->
          <router-link :to="{path:'/zhinengGG'}"><div class="dh_lb_bt">智能灌溉</div></router-link>
          <router-link :to="{path:'/binghai'}"><div class="dh_lb_bt">病虫害管理</div></router-link>
          <!-- <router-link :to="{path:'/plantmoxing'}"><div class="dh_lb_bt">种植模型</div></router-link> -->
          <!-- <router-link :to="{path:'/suyuan'}"><div class="dh_lb_bt">农业溯源</div></router-link> -->
          <!-- <router-link :to="{path:'/qihouYj'}"><div class="dh_lb_bt">气候灾害预警</div></router-link> -->
        </div>
        <div class="titleRightImg">
          <router-link :to="{ path: '/' }"><img :src="url+'/img/gbzntyj/sy.png'" class="return"/></router-link>
          <img :src="url+'/img/gbzntyj/fh.png'" class="return"  @click="clickReturn"/>
        </div>
      </div>
      <div class="leftBg"></div>
      <div class="left_txt">
        <div class="l_txt_middle">
          <h6>项目介绍</h6>
          <div class="l_txt_nt">
            <img src="../assets/img/plant/img.png" />
            <div class="textScroll">
                 <txtScroll>
                  <div v-for="item in textList" :key="item.id" class="scroll_item">
                    {{item.title}}
                  </div>  
                </txtScroll>
              </div>
          </div>
        </div>
        <div class="l_txt_top">
          <h6>视频巡检</h6>
          <div class="sp">
            <div class="sp_n" v-for="(item,index) in videoList" :key="index" @click="videoClick(index)">
              <img :src="item.img" />
              <div class="imgbg">{{item.name}}</div>
            </div>
          </div>
        </div>
        
        <div class="l_txt_bottom">
          <h6>病虫害预警</h6>
          <div class="l_txt_b_n">
            <div class="ld"><ldt /></div>
            <div class="cl"><dczz /></div>
          </div>
        </div>
      </div>
      <div class="db_dh"></div>
      <div class="d_h_n_r">
        <div class="sbx_b">
          <div class="xz_sbx"></div>
          <div class="xz_bj"></div>
          <div class="b_name">Lora基站</div>
        </div>
        <div class="sbx_b">
          <div class="xz_sbx"></div>
          <div class="xz_bj"></div>
          <div class="b_name">小型气象站</div>
        </div>
        <div class="sbx_b">
          <div class="xz_sbx"></div>
          <div class="xz_bj"></div>
          <div class="b_name">视频监控</div>
        </div>
        <div class="sbx_b">
          <div class="xz_sbx"></div>
          <div class="xz_bj"></div>
          <div class="b_name">电表监测</div>
        </div>
        <div class="sbx_b">
          <div class="xz_sbx"></div>
          <div class="xz_bj"></div>
          <div class="b_name">水表监测</div>
        </div>
        <div class="sbx_b">
          <div class="xz_sbx"></div>
          <div class="xz_bj"></div>
          <div class="b_name">水压传感器</div>
        </div>
        <div class="sbx_b">
          <div class="xz_sbx"></div>
          <div class="xz_bj"></div>
          <div class="b_name">电磁阀门</div>
        </div>
        <div class="sbx_b">
          <div class="xz_sbx"></div>
          <div class="xz_bj"></div>
          <div class="b_name">水肥一体机</div>
        </div>
        <div class="sbx_b">
          <div class="xz_sbx"></div>
          <div class="xz_bj"></div>
          <div class="b_name">滤水处理器</div>
        </div>
      </div>
  <footer1 />
  <popBg title="高标准农田" :popShow="popShow" @hiddlen="popHiddlen">
    <!-- <vue3VideoPlay id="video"  width="100%"  height="100%"  title="冰河世纪"  :src="videoList[curVideoIndex].options.src"  :type="videoList[curVideoIndex].options.type"  :autoPlay="true"/> -->
   <div style="width: 100%;height: 100%;" v-if="AccessToken!=''"> <iframe
      :src="videoList[curVideoIndex].options.src+AccessToken"
      width="100%"
      height="100%"
      id="ysOpenDevice"
      allowfullscreen
    >
    </iframe></div>
  </popBg>

</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";

// todo 项目使用请放开 leaflet 引入
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet/dist/leaflet.esm.js';
import Gep from "../utils/范围面.json";
import ldt from "../components/gbzntyj/ldt.vue";
import dczz from "../components/gbzntyj/dczz.vue";
import footer1 from "../components/footer.vue";
import txtScroll from "../components/xiaofeiChanpin/txtScroll.vue"
import popBg from "../components/popBg.vue"

export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();
    const mapRef = ref(null);
    const state = reactive({
      url:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      textList:[
        {title:'上蔡县5万亩高标准农田示范区建设项目涉及无量寺乡、黄埠镇2个乡镇的10个行政村，其中，其中无量寺乡涉'},
        {title:'及王连湖村、后陈村、吴宋村、陈寨庙村、郝庄村；黄埠镇涉及冯坡村、狮子口村、周庄村、后张村和常庄村等10个行政村。'},
        {title:'上蔡县5万亩高标准农田示范区建设项目涉及无量寺乡、黄埠镇2个乡镇的10个行政村，其中，其中无量寺乡涉'},
        {title:'及王连湖村、后陈村、吴宋村、陈寨庙村、郝庄村；黄埠镇涉及冯坡村、狮子口村、周庄村、后张村和常庄村等10个行政村。'},
        {title:'上蔡县5万亩高标准农田示范区建设项目涉及无量寺乡、黄埠镇2个乡镇的10个行政村，其中，其中无量寺乡涉'},
        {title:'及王连湖村、后陈村、吴宋村、陈寨庙村、郝庄村；黄埠镇涉及冯坡村、狮子口村、周庄村、后张村和常庄村等10个行政村。'},
        ] ,

      videoList:[
        {
          img:require("@/assets/img/gbzntyj/img1.jpg"),
          name:"高标准农田1",
          // "options": {
          //   src: "https://open.ys7.com/v3/openlive/AZ4145835_1_2.m3u8?expire=1740968991&id=686158739457310720&t=a2df278ad8ed05b87e2ba098d8e5aab421d37bad2cb06b2d858df79527b8f47d&ev=100", //视频源
          //   type: "m3u8", //视频类型
          // }
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          }
        },{
          img:require("@/assets/img/gbzntyj/img1.jpg"),
          name:"高标准农田2",
          // "options": {
          //   src: "https://open.ys7.com/v3/openlive/AY7450743_1_2.m3u8?expire=1740969297&id=686160021995081728&t=087c295c6d3b3acfaaf8d4cf32d46981de8713298a252bca3065ab24b89dfb63&ev=100", //视频源
          //   type: "m3u8", //视频类型
          // }
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538489/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          }
        },
        {
          img:require("@/assets/img/gbzntyj/img1.jpg"),
          name:"高标准农田3",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          }
         },
        {
          img:require("@/assets/img/gbzntyj/img1.jpg"),
          name:"高标准农田4",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538489/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          }
        }
      ],
      curVideoIndex:0,
      popShow:false,
      config: {
        // header: ['<span style="color:#038259;">网上名称</span>', '<span style="color:#038259;">归属地</span>', '<span style="color:#038259;">店铺数据</span>'],
        data: [
          ["1号地块", "120次", "88人", "100min"],
          ["2号地块", "170次", "88人", "100min"],
          ["3号地块", "150次", "88人", "100min"],
          ["4号地块", "220次", "88人", "100min"],
          ["5号地块", "620次", "88人", "100min"],
          ["6号地块", "420次", "88人", "100min"],
          ["7号地块", "520次", "88人", "100min"],
          ["8号地块", "320次", "88人", "100min"],
          ["9号地块", "720次", "88人", "100min"],
        ],
        headerBGC: "",
        oddRowBGC: "",
        evenRowBGC: "",
        // index: true,
        columnWidth: [150],
        align: ["center"],
        // rowNum:6
      },
      AccessToken:""
    });

    const emit = defineEmits(["mapLoad"]);
    const boundaryData = Gep;
    console.log(boundaryData);

    const marker = ref();
    const map = ref(null);
    let current = ref(0);

    // 地图底图
    // 第一种
    let mapType = ref("vec");
    let mapLabelType = ref("cva");

    // let mapType1 = ref(
    //   L.tileLayer(
    //     "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&x={x}&y={y}&z={z}",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );


    let mapType1 = ref(
      L.tileLayer(
        "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    let mapLabelType1 = ref(
      L.tileLayer(
        "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    // let mapLabelType1 = ref(
    //   L.tileLayer(
    //     "https://t{s}.tianditu.gov.cn/" +
    //       "cva" +
    //       "_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=" +
    //       "cva" +
    //       "&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );

    const initMap = () => {
      map.value.addLayer(mapType1.value);
      map.value.addLayer(mapLabelType1.value);
      map.value.on("click", ({ latlng }) => {
        console.log("坐标：", Object.values(latlng));
      });

      return map.value;
    };

    const mapObj = ref();

    // 在 onMounted 中初始化地图
    onMounted(() => {
      state.AccessToken = localStorage.getItem('AccessToken')
      console.log(state.AccessToken )
      map.value = L.map(mapRef.value, {
        center: [33.24715813736589, 114.12958145141602],

        // center: [114.182633, 33.240019],
        zoom: 13,
        minZoom: 3,
        maxZoom: 19,
        noWrap: true,
        // dragging: false,
        zoomControl: true,
        attributionControl: false,
      });
      mapObj.value = initMap();
      // createMarkers();
      loadBoundary();
    });

    function createDashedPolyline(feature, style) {
      const latLngs = feature.geometry.coordinates;
      if (feature.geometry.type === "Polygon") {
        // 取外圈线作为多段线处理
        latLngs = [latLngs[0]];
      } else if (feature.geometry.type === "MultiPolygon") {
        // 处理多个多边形，这里仅取第一个外圈线
        latLngs = [latLngs[0][0]];
      }

      const options = {
        ...style,
        dashArray: [5, 5], // 虚线长度与间距
        lineCap: "round", // 线头样式，可选
        lineJoin: "round", // 线交接处样式，可选
      };

      return L.polyline(latLngs, options);
    }

    // 添加行政区划边界的逻辑
    const loadBoundary = () => {
      L.geoJSON(boundaryData, {
        onEachFeature: function (feature, layer) {
          let style;

          switch (feature.properties.T) {
            case "未建成":
              style = {
                color: "green",
                fillColor: "green",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
              break;
            case "其他":
              style = {
                color: "green",
                fillColor: "green",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
              break;
            default:
              style = {
                color: "white",
                fillColor: "red",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
          }

          if (
            feature.geometry.type === "Polygon" ||
            feature.geometry.type === "MultiPolygon"
          ) {
            // 设置填充样式
            layer.setStyle(style);

            // 处理每个外环线为虚线
            feature.geometry.coordinates.forEach((ring, index) => {
              if (index === 0 || feature.geometry.type === "Polygon") {
                // 对于多边形，只处理外环线
                const dashedLine = createDashedPolyline(
                  { geometry: { coordinates: [ring] } },
                  style
                );
                map.value.addLayer(dashedLine);
              }
            });
          } else if (
            feature.geometry.type === "LineString" ||
            feature.geometry.type === "MultiLineString"
          ) {
            const dashedLine = createDashedPolyline(feature, style);
            map.value.addLayer(dashedLine);
          }

          // 添加原始图层到地图上（用于显示填充区域）
          map.value.addLayer(layer);
        },
      }).addTo(map.value);
    };

    const removeMap = () => {
      if (mapObj.value) {
        mapObj.value.remove();
      }
    };

    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
    // 弹出视频
    function videoClick(index){
      console.log(index)
      state.popShow = true
      state.curVideoIndex = index
    }
    // 关闭弹出
    function popHiddlen(){
      state.popShow = false
    }
    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
    });
    onUnmounted(() => {
      removeMap();
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),
      mapRef,
      clickReturn,
      videoClick,
      popHiddlen
    };
  },
  components: {
    ldt,
    dczz,
    footer1,
    txtScroll,
    popBg
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
::v-deep .d-player-wrap .d-player-control{
  height: 30px;
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index:2;
}
  .containerBg{
    position: absolute;
    width: 100%;
    height: 100%;
    // background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/bg.png") no-repeat;
    z-index: 999;
  }
  .dk_ss {
    width: 250px;
    h6 {
      font-size: 15px;

      color: #00eaff;
      line-height: 30px;
      text-align: center;
    }
    .dot_w {
      width: 100%;
    }
    .dot {
      width: 90%;
      margin: 5px 5%;
      height: 30px;
      line-height: 30px;
      font-size: 13px;
      color: #000;
    }
    .dot:before {
      content: "";
      display: inline-block;
      width: 5px;
      height: 5px;
      background-color: #00eaff;
      border-radius: 50%; /* 让其变成圆形 */
      margin-right: 6px;
    }
  }
  .bm-view {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
  }
  .dh_wz {
    width: 170px;
    height: 47px;
    position: absolute;
    left: 3%;
    top: 20%;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/yy.png") no-repeat top center;
    background-size: 100% 100%;

    .dh_wz_qq {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 7px;
      border: 1px solid #ffc600; /* 添加一个黑色的边框 */
      animation: guangying 2s linear infinite;
    }
    .dh_wz_tb {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 15px;
        top: 14px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/nt.png") no-repeat top center;
        background-size: 100% 100%;
        animation: topIcon 2s linear infinite;
        
      }
    .dh_wz_wz {
      width: 120px;
      height: 47px;
      line-height: 47px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      position: absolute;
      right: 5%;
    }
  }
  .topContent {
    width: 100%;
    height: 100px;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 34, 25, 1) 20%,
      rgba(0, 34, 25, 0)
    );
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    .titleRightImg {
      position: absolute;
      right: 0;
      top: 23%;
      .return {
        width: 77px;
        height: 32px;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        z-index: 999;
      }
    }
  }
  .leftBg {
    width: 100px;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(0, 34, 25, 1) 0%,
      rgba(0, 34, 25, 0.8) 20%,
      rgba(0, 0, 0, 0)
    );
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .dh_lb {
    // width: 900px;
    height: 45px;
    position: absolute;
    left: 23%;
    top: 20%;
    display: flex;
    flex-flow: row;
    a{
      text-decoration: none;
    }

    .dh_lb_bt {
      width: 124px;
      height: 43px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/yy.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;
    }
    .dh_lb_bt:hover,.dh_lb_bt_cur {
      width: 124px;
      height: 43px;
      cursor: pointer;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/xz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }
  .left_txt {
    width: 500px;
    height: 88%;
    position: absolute;
    top: 9%;
    left: 3%;
    display: flex;
    flex-direction: column;
    z-index: 10;
    .l_txt_top {
      width: 100%;
      height: 325px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/k/z1.png") no-repeat top center;
      background-size: 100% 100%;

      h6 {
        width: 100%;
        height: 20px;
        line-height: 20px;
        font-size: 15px;
        margin-top: 22px;
        text-align: left;
        text-indent: 2em;
        color: #fff;
      }
      .sp {
        width: 100%;
        height: 280px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .sp_n {
          width: 44%;
          height: 120px;
          margin-left: 4%;
          position: relative; 
          cursor: pointer;
          img{
            width: 100%;
            height: 100%;
          }
          .imgbg{
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,.2);
            top:0;
            left: 0;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
          }
        }
      }
    }
    .l_txt_middle {
      width: 100%;
      flex: 1;
      margin: 10px 0;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/k/z2.png") no-repeat top center;
      background-size: 100% 100%;
      position: relative;

      h6 {
        width: 100%;
        height: 15%;
        position: absolute;
        // line-height: 160%;
        font-size: 15px;
        top: 3%;
        text-align: left;
        text-indent: 2em;
        color: #fff;
        display: flex;
        align-items: center; /* 垂直居中 */
      }
      .l_txt_nt {
        width: 94%;
        height: 75%;
        position: absolute;
        left: 5%;
        top: 18%;
        display: flex;
        img{
          margin-top: 10px;
        }
        .textScroll{
              width: 100%;
              // height: 100%;
              font-size: 14px;
              line-height:24px;
              text-align: left;
              padding: 0 0 10px 0;
              box-sizing: border-box;
              // animation: textScroll 4s linear infinite;
              overflow: hidden;
              font-size: 14px;
              text-align: left;
              color:#fff;
            }

      }
    }
    .l_txt_bottom {
      width: 100%;
      flex: 1;
      margin: 10px 0;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/k/z3.png") no-repeat top center;
      background-size: 100% 100%;
      position: relative;

      h6 {
        width: 100%;
        height: 15%;
        position: absolute;
        // line-height: 160%;
        font-size: 15px;
        top: 3%;
        text-align: left;
        text-indent: 2em;
        color: #fff;
        display: flex;
        align-items: center; /* 垂直居中 */
      }
      .l_txt_b_n {
        width: 100%;
        height: 75%;
        position: absolute;
        top: 20%;
        display: flex;
        flex-wrap: wrap;
        .ld {
          width: 55%;
          height: 100%;
        }
        .cl {
          width: 45%;
          height: 100%;
        }
      }
    }
  }
  .db_dh {
    width: 950px;
    height: 66px;
    position: absolute;
    left: 33%;
    bottom: 10%;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/dc.png") no-repeat top center;
    background-size: 100% 100%;
    z-index: 10;
  }
  .d_h_n_r {
    width: 950px;
    height: 100px;
    position: absolute;
    z-index: 10;
    // border: #fff 1px solid;
    left: 33%;
    bottom: 10%;
    display: flex;
    flex-wrap: wrap;
    .sbx_b {
      width: 105px;
      height: 100px;
      // border: #3bf4be 1px solid;
      .xz_sbx {
        width: 60px;
        height: 66px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/wq.png") no-repeat top center;
        background-size: 100% 100%;
        margin-left: 22.5px;
        position: relative;
        // animation: guangying 3s linear infinite;
      }
      .xz_bj {
        width: 73px;
        height: 80px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gbzntyj/jb.gif") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: -9px;
        margin-left: 15px;
      }
      .b_name {
        width: 100%;
        height: 25px;
        line-height: 25px;
        font-size: 14px;
        color: #fff;
        text-align: center;
      }
    }
  }

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}

#video .d-player-wrap .d-player-control{
  height: 50px;
}
</style>
